/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Autocomplete, Popper, TextField } from "@mui/material";
import { useField } from "formik";
import { OpcionSelect } from "./TextInput";

export type ItextInputProps = {
  label: string;
  type: string;
  name: string;
  InputProps?: any;
  InputLabelProps?: any;
  id?: string;
  setValue?: (value: string) => void;
  opciones?: OpcionSelect[];
};

const CustomAutocomplete = (props: ItextInputProps) => {
  const [field, meta, helpers] = useField(props);
  const { label, opciones, ...rest } = props;

  const [inputValue, setInputValue] = useState("");

  const handleChange = (_: any, newValue: OpcionSelect | null) => {
    helpers.setValue(newValue ? newValue.valor : "");
    rest.setValue ? rest.setValue(newValue ? newValue.valor : ""): null;
  };

  const handleInputChange = (_: any, newInputValue: string) => {
    setInputValue(newInputValue);
  };

  const selectedOption =
    opciones?.find((option) => option.valor === field.value) || null;

  return (
    <Autocomplete
      {...rest}
      value={selectedOption}
      onChange={handleChange}
      inputValue={inputValue}
      size="small"
      onInputChange={handleInputChange}
      options={opciones || []}
      getOptionLabel={(option: OpcionSelect) => option.label as string}
      fullWidth
      sx={{ display: "flex", justifyContent: "center", paddingY: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          {...rest}
          name={field.name}
          label={label}
          autoComplete="off"
          error={!!(meta.touched && meta.error)}
          helperText={meta.touched && meta.error ? meta.error : ""}
          variant="outlined"
          fullWidth
        />
      )}
    />
  );
};

export default CustomAutocomplete;
